const appProduction = {
  nbContactsToBeAnAppBoss: 1,
  configVersion: "Production",
};

export {
  appProduction,
};

